import React from 'react';

// Whether the enclosing tab pane is the active tab; true outside of any tab.
export const TabActiveContext = React.createContext<boolean>(true);
